import { ScrapRule } from './scrap-rule'
import { BomMatcher } from '../../../matcher/bom-matcher'
import { ScrapConsumptionSelector } from './selectors/scrap-consumption-selector'
import { ScrapFinishedSelector } from './selectors/scrap-finished-selector'

export class ScrapSpec {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public name: string

  /**
   * Only used in FrontEnd to distinguish between each other!
   */
  public id: string

  /**
   * Properties for scrap calculation in consumptionBom
   */
  public consumptionSelector: ScrapConsumptionSelector
  public consumptionComponentPath: string
  public consumptionComponentMatcher: BomMatcher

  /**
   * Properties for scrap disclosure in finishedBom
   */
  public finishedSelector: ScrapFinishedSelector
  public finishedComponentPath: string
  public finishedComponentMaterialId: string
  public finishedComponentName: string

  /**
   * Conditional scrap quantity definitions
   */
  public rules: ScrapRule[]

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.name = ''
    this.consumptionSelector = ScrapConsumptionSelector.PATH
    this.consumptionComponentPath = ''
    this.consumptionComponentMatcher = new BomMatcher()
    this.finishedSelector = ScrapFinishedSelector.PATH
    this.finishedComponentPath = ''
    this.finishedComponentMaterialId = ''
    this.finishedComponentName = 'scrap' // TODO: move to backend, this controls bom structure
    this.rules = []
  }
}
